export const markLinksFromString = (input: string): string => {
    return input.replace(
        /<a\s+([^<]*\s)?href="(?!https?:\/\/|mailto:|tel:)[^"]+".*?>.*?<\/a>/g,
        (match: string): string => match.replace(/^<a/, "<a data-internal-link-from-string='true'")
    );
};
